import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Mail, Calendar, User, Target } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminPage = () => {
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchSubscriptions();
  }, []);

  const fetchSubscriptions = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API}/subscriptions`);
      setSubscriptions(response.data);
      setError(null);
    } catch (err) {
      setError('Error al cargar las suscripciones');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getObjectiveLabel = (objective) => {
    const labels = {
      'energia': 'Energía y vitalidad',
      'estres': 'Estrés y descanso',
      'digestion': 'Digestión y microbiota',
      'defensas': 'Defensas y bienestar general',
      'enfoque': 'Enfoque y rendimiento diario',
      'salud-integral': 'Salud integral a largo plazo'
    };
    return labels[objective] || objective;
  };

  if (loading) {
    return (
      <div className="admin-page">
        <div className="container">
          <div className="admin-loading">Cargando suscripciones...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-page">
      <div className="container">
        <div className="admin-header">
          <h1>Panel de Administración</h1>
          <p className="admin-subtitle">Suscripciones de Guía de Suplementos</p>
        </div>

        {error && (
          <div className="admin-error">
            {error}
          </div>
        )}

        <div className="admin-stats">
          <div className="stat-card">
            <Mail size={32} />
            <div className="stat-info">
              <span className="stat-number">{subscriptions.length}</span>
              <span className="stat-label">Total Suscripciones</span>
            </div>
          </div>
        </div>

        <div className="subscriptions-table-container">
          {subscriptions.length === 0 ? (
            <div className="no-data">
              <p>No hay suscripciones aún</p>
            </div>
          ) : (
            <table className="subscriptions-table">
              <thead>
                <tr>
                  <th><User size={16} /> Nombre</th>
                  <th><Mail size={16} /> Email</th>
                  <th><Target size={16} /> Objetivo</th>
                  <th><Calendar size={16} /> Fecha</th>
                </tr>
              </thead>
              <tbody>
                {subscriptions.map((sub) => (
                  <tr key={sub.id}>
                    <td>{sub.name}</td>
                    <td>{sub.email}</td>
                    <td><span className="objective-badge">{getObjectiveLabel(sub.objective)}</span></td>
                    <td>{formatDate(sub.created_at)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default AdminPage;